// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"95":"fc765f08","132":"1917a2e0","750":"80b17838"}[chunkId] + ".js";
};